import { createStyles, makeStyles } from '@mui/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    error: {
      color: '#f44336',
      margin: 0,
      fontSize: '0.75rem',
      marginTop: '3px',
      textAlign: 'left',
      fontFamily: 'Poppins,sans-serif',
      fontWeight: 400,
      lineHeight: 1.66
    }
  })
)
